import { render, staticRenderFns } from "./create-card-collect.vue?vue&type=template&id=5d1cb6f0&scoped=true"
import script from "./create-card-collect.vue?vue&type=script&lang=js"
export * from "./create-card-collect.vue?vue&type=script&lang=js"
import style0 from "./create-card-collect.vue?vue&type=style&index=0&id=5d1cb6f0&prod&lang=scss&scoped=true"
import style1 from "./create-card-collect.vue?vue&type=style&index=1&id=5d1cb6f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cb6f0",
  null
  
)

export default component.exports